var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.userExam.finishedAt
    ? _c(
        "v-layout",
        {
          staticClass: "exam-result px-4 py-3",
          attrs: { "justify-content-center": "", wrap: "" },
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c("v-layout", [
                _c(
                  "div",
                  {
                    staticClass: "d-flex",
                    staticStyle: { "flex-wrap": "wrap", width: "100%" },
                  },
                  [
                    _c(
                      "multipane",
                      {
                        staticStyle: { flex: "1" },
                        attrs: { layout: "vertical" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: { width: "75%", "max-width": "100%" },
                          },
                          [
                            _vm.getBanner("exam_result_top")
                              ? [
                                  _c("div", {
                                    staticClass:
                                      "container p-4 container--fluid",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getBanner("exam_result_top")
                                          .bodyHtml
                                      ),
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-card",
                              { staticClass: "p-0 exam-result-card" },
                              [
                                _vm._t("result-head"),
                                _vm._v(" "),
                                _c(
                                  "v-container",
                                  {
                                    staticClass: "p-2",
                                    attrs: {
                                      fluid: "",
                                      "grid-list-lg": "",
                                      "fill-height": "",
                                      "text-xs-center": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass:
                                          "result-title p-3 white-text",
                                        attrs: {
                                          row: "",
                                          wrap: "",
                                          "align-center": "",
                                        },
                                      },
                                      [
                                        _c("v-flex", { attrs: { xs12: "" } }, [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "headline m-0 text-sm-start",
                                            },
                                            [_vm._v(_vm._s(_vm.exam.name))]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "d-flex w-full" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center align-center",
                                                attrs: { "text-xs-center": "" },
                                              },
                                              [
                                                _c(
                                                  "v-progress-circular",
                                                  {
                                                    staticClass: "m-2",
                                                    attrs: {
                                                      rotate: 270,
                                                      size: 150,
                                                      width: 15,
                                                      value:
                                                        _vm.userExam.average,
                                                      color: "white",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "align-center text-align-center",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-h3",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.userExam
                                                                  .average
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "margin-top":
                                                                "-10px",
                                                            },
                                                          },
                                                          [_vm._v("%")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "d-flex w-full" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-sm-start w-30",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "exam-status-result pe-3 ps-3",
                                                        class: {
                                                          pass: _vm.userExam
                                                            .passed,
                                                          failure:
                                                            !_vm.userExam
                                                              .passed,
                                                        },
                                                      },
                                                      [
                                                        _vm.userExam.passed
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "white",
                                                                },
                                                              },
                                                              [_vm._v("done")]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.userExam
                                                                .passed
                                                                ? _vm.$t(
                                                                    "exam_result.pass",
                                                                    {
                                                                      format:
                                                                        _vm
                                                                          .LETTER_FORMAT
                                                                          .UPTITLECASE,
                                                                    }
                                                                  )
                                                                : _vm.$t(
                                                                    "exam_result.failure",
                                                                    {
                                                                      format:
                                                                        _vm
                                                                          .LETTER_FORMAT
                                                                          .UPTITLECASE,
                                                                    }
                                                                  )
                                                            ) +
                                                            "\n                        "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    !_vm.exam.canRetest
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mt-3",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "headline",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .userExam
                                                                        .position
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "exam_result.place"
                                                                    )
                                                                  ) +
                                                                  "\n                            "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "caption",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " / " +
                                                                      _vm._s(
                                                                        _vm.exam
                                                                          .usersCount
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "exam_result.people"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mt-3",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "exam_result.national_average",
                                                                      {
                                                                        format:
                                                                          _vm
                                                                            .LETTER_FORMAT
                                                                            .UPTITLECASE,
                                                                      }
                                                                    )
                                                                  ) +
                                                                  ":\n                            "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "caption",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.exam
                                                                          .averageRate
                                                                      ) +
                                                                      "% "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mt-3 d-none",
                                                      },
                                                      [
                                                        _c("FbShareButton", {
                                                          attrs: {
                                                            url: _vm.shareUrl,
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("TwShareButton", {
                                                          staticClass: "mt-1",
                                                          attrs: {
                                                            url: _vm.shareUrl,
                                                            text: _vm.shareText,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _vm.exam.isShowEvaluation
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "w-70" },
                                                      [
                                                        _c("SkillsChart", {
                                                          attrs: {
                                                            skills: _vm.skills,
                                                            "user-exam":
                                                              _vm.userExam,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-tabs",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.exam.isShowEvaluation,
                                        expression: "exam.isShowEvaluation",
                                      },
                                    ],
                                    model: {
                                      value: _vm.bodyTab,
                                      callback: function ($$v) {
                                        _vm.bodyTab = $$v
                                      },
                                      expression: "bodyTab",
                                    },
                                  },
                                  [
                                    _c("v-tab", { key: "evaluation" }, [
                                      _vm._v("診断結果"),
                                    ]),
                                    _vm._v(" "),
                                    _c("v-tab", { key: "skill" }, [
                                      _vm._v("スタッツ詳細"),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-tabs-items",
                                  {
                                    staticClass: "h-full",
                                    model: {
                                      value: _vm.bodyTab,
                                      callback: function ($$v) {
                                        _vm.bodyTab = $$v
                                      },
                                      expression: "bodyTab",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-tab-item",
                                      { key: "evaluation" },
                                      [
                                        _c("ExamEvaluationComponent", {
                                          attrs: {
                                            examEvaluations:
                                              _vm.exam.examEvaluations,
                                            score: _vm.userExam.average,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-tab-item",
                                      { key: "skill" },
                                      [
                                        _vm._l(
                                          _vm.skills,
                                          function (skill, index) {
                                            return [
                                              _c("ExamSkillReport", {
                                                key: index,
                                                attrs: {
                                                  skill: skill,
                                                  userExam: _vm.userExam,
                                                },
                                              }),
                                              _vm._v(" "),
                                              index + 1 < _vm.skills.length
                                                ? _c("v-divider", {
                                                    key: index + skill.name,
                                                    staticClass: "m-0",
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm._l(
                                                skill.skillItems,
                                                function (
                                                  skillItem,
                                                  indexItem
                                                ) {
                                                  return [
                                                    _c("ExamSkillItemReport", {
                                                      key:
                                                        skillItem.name +
                                                        indexItem,
                                                      attrs: {
                                                        skillItem: skillItem,
                                                        userExam: _vm.userExam,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    indexItem + 1 <
                                                    skill.skillItems.length
                                                      ? _c("v-divider", {
                                                          key:
                                                            index +
                                                            skillItem.name +
                                                            indexItem,
                                                          staticClass: "m-0",
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                }
                                              ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._t("result-body"),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.getBanner("exam_result_bottom")
                              ? [
                                  _c("div", {
                                    staticClass:
                                      "container p-4 container--fluid",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getBanner("exam_result_bottom")
                                          .bodyHtml
                                      ),
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("multipane-resizer", {
                          staticStyle: {
                            width: "2px",
                            border: "2px solid #e0e0e0",
                            margin: "0 5px",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            ref: "rightSideBar",
                            staticStyle: { "flex-grow": "1", width: "25%" },
                          },
                          [
                            _c(
                              "v-card",
                              {
                                ref: "rightSideBarCard",
                                staticClass: "p-0",
                                staticStyle: {
                                  position: "fixed",
                                  height: "calc(100% - 100px)",
                                },
                              },
                              [
                                _c(
                                  "v-card-title",
                                  {
                                    staticClass:
                                      "ps-0 pe-0 question-report-list fill-height",
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { staticClass: "fill-height" },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "fill-height",
                                            attrs: { xs12: "" },
                                          },
                                          [
                                            _c(
                                              "v-tabs",
                                              {
                                                model: {
                                                  value: _vm.tab,
                                                  callback: function ($$v) {
                                                    _vm.tab = $$v
                                                  },
                                                  expression: "tab",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-tab",
                                                  { key: "question" },
                                                  [_vm._v("Questions")]
                                                ),
                                                _vm._v(" "),
                                                _vm.useAiChatExam
                                                  ? _c(
                                                      "v-tab",
                                                      { key: "chat" },
                                                      [_vm._v("チャット")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.useAiChatExam
                                                  ? _c(
                                                      "v-tab",
                                                      { key: "thread" },
                                                      [_vm._v("スレッド")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.useAiChatExam
                                                  ? _c("div", {
                                                      staticStyle: {
                                                        "padding-right": "40px",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.useAiChatExam
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "btn-new-chat",
                                                        attrs: { icon: true },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.emitCreateThread(
                                                              1
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "v-icon material-icons theme--dark",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "add_comment"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-tabs-items",
                                              {
                                                staticClass: "h-full",
                                                model: {
                                                  value: _vm.tab,
                                                  callback: function ($$v) {
                                                    _vm.tab = $$v
                                                  },
                                                  expression: "tab",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-tab-item",
                                                  {
                                                    key: "question",
                                                    staticStyle: {
                                                      height:
                                                        "calc(100% - 34px)",
                                                      "overflow-y": "auto",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list",
                                                      {
                                                        staticClass:
                                                          "report-list",
                                                      },
                                                      [
                                                        _vm._l(
                                                          _vm.sortedGroupQuest,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return [
                                                              _c(
                                                                "ExamResultQuestionGroupList",
                                                                {
                                                                  key:
                                                                    index +
                                                                    "group",
                                                                  attrs: {
                                                                    item: item,
                                                                    padding: true,
                                                                    questionNumber:
                                                                      _vm.getQuestionNumber(
                                                                        item
                                                                      ),
                                                                    exam: _vm.exam,
                                                                    "user-exam":
                                                                      _vm.userExam,
                                                                    examQScoreHistory:
                                                                      _vm.examQScoreHistory,
                                                                  },
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              index + 1 <
                                                              _vm.groupQuestions
                                                                .length
                                                                ? _c(
                                                                    "v-divider",
                                                                    {
                                                                      key:
                                                                        index +
                                                                        "group_divider",
                                                                      staticClass:
                                                                        "my-0",
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _vm.useAiChatExam
                                                  ? _c(
                                                      "v-tab-item",
                                                      {
                                                        key: "chat",
                                                        staticStyle: {
                                                          height:
                                                            "calc(100% - 34px)",
                                                        },
                                                      },
                                                      [
                                                        _c("MesageContainer", {
                                                          key: _vm.exam.id,
                                                          ref: "mesageContainer",
                                                          staticClass: "h-full",
                                                          attrs: {
                                                            targetableId:
                                                              _vm.exam.id,
                                                            targetableType:
                                                              "Exam",
                                                            "using-deepseek":
                                                              _vm.schoolSetting
                                                                .usingDeepSeek,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.useAiChatExam
                                                  ? _c(
                                                      "v-tab-item",
                                                      {
                                                        key: "thread",
                                                        staticStyle: {
                                                          height:
                                                            "calc(100% - 34px)",
                                                        },
                                                      },
                                                      [
                                                        _c("ThreadContainer", {
                                                          key: _vm.exam.id,
                                                          staticClass: "h-full",
                                                          attrs: {
                                                            targetableId:
                                                              _vm.exam.id,
                                                            targetableType:
                                                              "Exam",
                                                          },
                                                          on: {
                                                            updateParentTab:
                                                              _vm.updateParentTab,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }